var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{class:[
    'booking-status__label',
    ("booking-status__label--" + (_vm.status.toLowerCase()))
  ]},[_vm._v(" "+_vm._s(_vm.$t(("booking_summary.status.type." + (_vm.status.toLowerCase()))))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }